import {Component, Input, OnInit} from '@angular/core';
import {Country, EventItem, Lookups, Race} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {LocalizedDatePipe} from "@pipes";
import {LiveItemStatus} from "../../../model/live-item-status";
import {LIVE_RESULTS_RACE_DETAILS, LIVE_RESULTS_RACE_DETAILS_FULL_SCREEN} from "../../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "@environment";

@Component({
  selector: 'app-live-race-list-item',
  templateUrl: './live-race-list-item.component.html',
  styleUrls: ['./live-race-list-item.component.scss']
})
export class LiveRaceListItemComponent implements OnInit {

  @Input() race: Race | undefined;
  @Input() event: EventItem | undefined
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];

  LiveItemStatus = LiveItemStatus;

  status: LiveItemStatus = LiveItemStatus.TO_BE_STARTED;
  localizedDatePipe: LocalizedDatePipe;

  constructor(public translocoService: TranslocoService, private router: Router, private route: ActivatedRoute) {
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }

  ngOnInit(): void {
    this.startRaceTimer();
  }

  private startRaceTimer(): void {
    if (this.race && this.race.raceStart) {
      const start = new Date(this.race.raceStart).getTime();
      const end = this.race.raceEnd ? new Date(this.race.raceEnd).getTime() : Infinity;
      const now = new Date().getTime();
      const limit = environment.dayInSeconds;
      if (now < start) {
        this.status = LiveItemStatus.TO_BE_STARTED;
        if (now + limit > start) {
          setTimeout(() => {
            this.status = LiveItemStatus.IN_PROGRESS;
            if (limit > end - start) {
              setTimeout(() => {
                this.status = LiveItemStatus.FINISHED;
              }, end - start);
            }
          }, start - now);
        }
        return
      }
      if (now > end) {
        this.status = LiveItemStatus.FINISHED;
        return
      } else {
        this.status = LiveItemStatus.IN_PROGRESS;
        if (now + limit > end) {
          setTimeout(() => {
            this.status = LiveItemStatus.FINISHED;
          }, end - now);
        }
        return;
      }
    }
  }

  goToRaceLiveResultsPage(fullScreen: boolean = false): void {
    if (this.race?.id && this.event?.id) {
      this.router.navigate([fullScreen ? LIVE_RESULTS_RACE_DETAILS_FULL_SCREEN : LIVE_RESULTS_RACE_DETAILS], {
        relativeTo: this.route,
        queryParams: {eventId: this.event.id, raceId: this.race.id}
      });
    }
  }
}
